import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SchoolReportSectionsUIHelpers";

const SchoolReportSectionsUIContext = createContext();

export function useSchoolReportSectionsUIContext() {
  return useContext(SchoolReportSectionsUIContext);
}

export const SchoolReportSectionsUIConsumer = SchoolReportSectionsUIContext.Consumer;

export function SchoolReportSectionsUIProvider({ term, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    term,
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams
  };

  return (
    <SchoolReportSectionsUIContext.Provider value={value}>
      {children}
    </SchoolReportSectionsUIContext.Provider>
  );
}